export default "__VITE_ASSET__d51a2c2c__"